import React, { ReactNode } from 'react';

import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { State, useState } from '@hookstate/core';
import {
  Container,
  Overlay,
  Delete,
  Cancel,
  Buttons,
  Header,
  Text,
  RowDiv,
  CloseButton,
  InputTextCheckWrapper,
  InputTextCheck,
  InputTextCheckSpan,
  InputCheckFieldWrapper,
  InputCheckField,
  DeleteButton,
} from './Deletedialog.styles';

interface OwnProps {
  open: State<boolean>;
  onDelete: () => void;
  onDeleteLoading?: boolean;
  onCancel?: () => void;
  width?: number | string;
  title?: string;
  text?: string | ReactNode;
  buttonText?: string;
  cancelText?: string;
  hideCancel?: boolean;
  backgroundColor?: string;
  showSave?: boolean;
  saveText?: string;
  onSave?: (clear: VoidFunction) => void;
  inputCheck?: boolean;
  textConfimation?: string;
}

export const DeleteDialog = (props: OwnProps) => {
  const {
    open,
    onDelete,
    onDeleteLoading,
    onCancel,
    title,
    text,
    buttonText,
    cancelText,
    hideCancel,
    width,
    backgroundColor,
    showSave,
    saveText,
    onSave,
    inputCheck,
    textConfimation = 'delete import data',
  } = props;
  const portalDiv = document.getElementById('portal');
  const blockButton = useState(false);
  const inputCheckValue = useState<string>('');

  return open.get() && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container width={width}>
            <RowDiv
              onClick={() => {
                open.set(false);
                if (onCancel) onCancel();
              }}
            >
              <Header>{title || 'Are you sure?'}</Header>
              <CloseButton>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </RowDiv>
            <Text data-inputcheck={inputCheck}>
              {text || 'This action cannot be undone.'}
            </Text>

            {inputCheck && (
              <InputTextCheckWrapper>
                <InputTextCheck>
                  Please type{' '}
                  <InputTextCheckSpan>{textConfimation}</InputTextCheckSpan> to
                  confirm
                </InputTextCheck>
                <InputCheckFieldWrapper>
                  <InputCheckField
                    type="text"
                    onChange={e => inputCheckValue.set(e.target.value)}
                    value={inputCheckValue.get()}
                  />

                  {inputCheckValue.get() && (
                    <BlueIcon
                      icon="cross"
                      color="#8F95B2"
                      onClick={() => inputCheckValue.set('')}
                    />
                  )}
                </InputCheckFieldWrapper>
              </InputTextCheckWrapper>
            )}
            <Buttons>
              {showSave && (
                <Cancel
                  onClick={() => {
                    if (!onSave) return;
                    blockButton.set(true);
                    onSave(() => blockButton.set(false));
                  }}
                >
                  {saveText || 'Save'}
                </Cancel>
              )}

              {!hideCancel ? (
                <Cancel
                  onClick={() => {
                    open.set(false);
                    if (onCancel) onCancel();
                  }}
                >
                  {cancelText || 'Cancel'}
                </Cancel>
              ) : (
                <div />
              )}

              {inputCheck ? (
                <DeleteButton
                  onClick={onDelete}
                  disabled={
                    inputCheckValue.get() !== textConfimation || onDeleteLoading
                  }
                >
                  {buttonText || 'Delete'}
                </DeleteButton>
              ) : (
                <Delete
                  backgroundColor={backgroundColor}
                  blocked={blockButton.get()}
                  onClick={() => {
                    if (!blockButton.get()) onDelete();
                    blockButton.set(true);
                  }}
                >
                  {buttonText || 'Delete'}
                </Delete>
              )}
            </Buttons>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
